import { type FC } from 'react'

import { ProductHeadLabelRenderer } from './ProductHeadLabelRenderer'

export const ProductHeadLabels: FC = () => {
  return <ProductHeadLabelRenderer />
}
